export default __webpack_public_path__ + "static/media/05.95f5b3da.svg";